/**
 * Meet het verzenden van een nieuwsbriefinschrijving.
 *
 * WAAR DIT HOORT
 * Als asset, ingeladen onderaan de <body>.
 *
 * TWEE MANIEREN VAN METEN
 *
 * 1. Op submit (nieuwsbrief_selector).
 *    Voor een gewoon formulier dat de pagina herlaadt. Simpel, maar telt ook
 *    pogingen die mislukken.
 *
 * 2. Op succes (nieuwsbrief_succes_selector).
 *    Voor een formulier dat via JavaScript verstuurt. Dan blijft de pagina
 *    staan en zegt een berichtje of het gelukt is. Meten op submit telt daar
 *    ook een verkeerd ingevuld e-mailadres of een API die eruit ligt mee, en
 *    dan lijkt de inschrijvingsgraad hoger dan hij is.
 *
 * Vul de succes-selector in als het formulier via JavaScript gaat; dan wordt
 * de submit-listener niet gebruikt. Het element moet met het `hidden`-attribuut
 * verborgen zijn en dat verliezen zodra het gelukt is.
 *
 * WAAROM NIET IN GTM
 * GTM draait in de sandbox van de Shopify-pixel en ziet de DOM van de
 * winkelpagina niet. Het theme publiceert het event via
 * Shopify.analytics.publish; de pixel vangt het op.
 */
(function () {
  var SELECTOR = "";
  var SUCCES_SELECTOR = ".nl-success";

  function publiceer() {
    if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
      // Alleen dát er is ingeschreven, niet wát er is ingevuld. De inhoud van
      // een formulier is klantdata en hoort niet in de dataLayer.
      window.Shopify.analytics.publish("formulier_verzonden", {
        formulier_type: "newsletter_signup",
      });
    }
  }

  /* ---- 2. op succes ---- */
  if (SUCCES_SELECTOR) {
    var gemeld = false;

    /**
     * Twee soorten formulieren, één selector.
     *
     * Verstuurt het formulier via JavaScript, dan staat het succesbericht al
     * in de pagina met het hidden-attribuut en verliest het dat zodra het
     * gelukt is. Daar wachten we op.
     *
     * Herlaadt het formulier de pagina, dan staat het succesbericht er na de
     * herlaad meteen zichtbaar in, en alleen dan. De aanwezigheid ervan ís het
     * signaal.
     */
    function bekijk(element) {
      if (!element.hidden) {
        if (!gemeld) {
          gemeld = true;
          publiceer();
        }
        return;
      }
      new MutationObserver(function (mutaties) {
        for (var i = 0; i < mutaties.length; i += 1) {
          if (!mutaties[i].target.hidden && !gemeld) {
            gemeld = true;
            publiceer();
          }
        }
      }).observe(element, { attributes: true, attributeFilter: ["hidden"] });
    }

    var pogingen = 0;
    (function zoek() {
      var gevonden = document.querySelectorAll(SUCCES_SELECTOR);
      if (gevonden.length) {
        for (var i = 0; i < gevonden.length; i += 1) bekijk(gevonden[i]);
        return;
      }
      // Het formulier kan later in de DOM komen, bijvoorbeeld in een sectie die
      // pas bij scrollen laadt.
      if (pogingen++ < 20) {
        setTimeout(zoek, 250);
        return;
      }
      // Geen waarschuwing: op de meeste pagina's staat dit formulier gewoon
      // niet, en dat is geen fout. Alleen zichtbaar met debug aan.
      console.debug(
        "[newsletter_signup] geen formulier op deze pagina (" + SUCCES_SELECTOR + ")"
      );
    })();
    return;
  }

  /* ---- 1. op submit ---- */
  if (!SELECTOR) return;

  document.addEventListener(
    "submit",
    function (e) {
      var formulier = e.target;
      if (!formulier || formulier.tagName !== "FORM") return;

      var raak = false;
      try {
        raak = formulier.matches(SELECTOR) || Boolean(formulier.closest(SELECTOR));
      } catch (err) {
        console.warn("[newsletter_signup] ongeldige selector: " + SELECTOR);
        return;
      }
      if (raak) publiceer();
    },
    true
  );
})();
